<div>

  <div class="_wrapper">
    <span
      class="_left"
      [ngClass]="width ?width: 'w-[175px]'"
    >{{"auditField.createdAt" | translate}}</span>
    <span class="_right">{{!createdAt ? '-' : createdAt | libDate: 'dateTime'}}</span>
  </div>

  <div class="_wrapper">
    <span
      class="_left"
      [ngClass]="width ?width: 'w-[175px]'"
    >{{"auditField.createdBy" | translate}}</span>
    <span class="_right">{{createdUsername ? createdUsername : '-'}}</span>
  </div>

  <div class="_wrapper">
    <span
      class="_left"
      [ngClass]="width ?width: 'w-[175px]'"
    >{{"auditField.lastUpdatedDate" | translate}}</span>
    <span class="_right">{{!updatedAt ? '-' : updatedAt | libDate: 'dateTime'}}</span>
  </div>
  <div class="_wrapper">
    <span
      class="_left"
      [ngClass]="width ?width: 'w-[175px]'"
    >{{"auditField.lastUpdatedBy" | translate}}</span>
    <span class="_right">{{updatedUsername ? updatedUsername : '-'}}</span>
  </div>
</div>